import React from "react";
import { Modal } from "react-bootstrap";
import { Dropdown } from "react-bootstrap";
import ProductBrief from "../../Layout/Product/ProductBrief";
import Blocker from "../Blocker";
import allDocuments from "../../Layout/Workdoc/typedoc";
export default class Cart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      checkedItems: {},
    };
  }

  onDelete = async (id) => {
    if (id) {
      const { cart } = this.props.context;
      this.setState({ pending: true });
      await cart.deleteItem(id);
      this.setState({ pending: false });
    }
  };

  onDeleteChecked = async () => {
    let { checkedItems } = this.state;
    const { cart } = this.props.context;
    this.setState({ pending: true });
    await cart.deleteItems(Object.keys(checkedItems));
    this.setState({ pending: false });
  };

  onItemCheck = (id) => {
    let { checkedItems } = this.state;
    if (checkedItems[id]) {
      checkedItems[id] = false;
    } else {
      checkedItems[id] = true;
    }
    this.setState({ checkedItems });
  };

  onItemCheckAll = () => {
    let checkedItems = {};
    const { cart } = this.props.context;
    cart.cartItems.forEach((item) => {
      checkedItems[item.id] = true;
    });
    this.setState({ checkedItems });
  };

  onItemUnCheckAll = () => {
    this.setState({ checkedItems: {} });
  };

  onDocumentClick = (document) => {
    let ids = this.getItemsIDs();
    this.props.context.redirect(
      document.url + "/?append=" + ids[document.cartObjects].join(",")
    );
    this.props.onHide();
  };

  getItemsIDs = () => {
    const { cart } = this.props.context;
    const { checkedItems } = this.state;

    let ids = {
      model: [],
      product: [],
    };
    cart.cartItems.forEach((item) => {
      if (checkedItems[item.id]) {
        if (item.classcode === "model") {
          ids.model.push(item.id);
        }
        if (item.classcode === "product") {
          ids.product.push(item.id);
          let itemData = cart.cartItemsData[item.id] || {};
          if (itemData.model) {
            ids.model.push(itemData.model);
          }
        }
      }
    });
    return ids;
  };

  getAvailableDocuments = () => {
    let avDocuments = [];
    allDocuments.forEach((doc) => {
      if (doc.inCart) {
        if (this.isDocumentAccessible(doc.key)) {
          avDocuments.push(doc);
        }
      }
    });
    return avDocuments;
  };

  isDocumentAccessible = (essence) => {
    let access = this.props.context.user.classAccess[essence] || {};
    if (access.c || access.u || access.d) {
      return true;
    }
    return false;
  };

  renderItem = (item = {}) => {
    const { checkedItems } = this.state;

    return (
      <div
        key={item.id}
        className="py-5 border-bottom d-flex justify-content-between align-items-center"
      >
        <div className="flex-grow-1">
          <label className="checkbox">
            <input
              type="checkbox"
              onChange={(e) => this.onItemCheck(item.id)}
              checked={checkedItems[item.id] ? true : false}
            />
            <span className="mr-2"></span>
            {this.renderItemLabel(item)}
          </label>
          {this.renderItemData(item)}
        </div>

        <i
          title="Удалить"
          className="fa fa-times text-hover-danger cursor-pointer"
          onClick={() => this.onDelete(item.id)}
        ></i>
      </div>
    );
  };

  renderItemLabel = (item) => {
    if (item.classcode === "model") {
      return <div title="ЗИП">{item.label}</div>;
    }
    if (item.classcode === "product") {
      return (
        <div title="Складская позиция">
          <span className="text-muted mr-2">Складская позиция:</span>
          {item.label}
        </div>
      );
    }
  };

  renderItemData = (item) => {
    const { cart } = this.props.context;
    const itemData = cart.cartItemsData[item.id] || {};

    if (item.classcode === "product") {
      return (
        <div className="pl-5 ml-2 pb-2 pt-2 w-75">
          <ProductBrief {...itemData} />
        </div>
      );
    }
  };

  render() {
    const { cart } = this.props.context;
    const documents = this.getAvailableDocuments();
    return (
      <>
        <Modal size="lg" show onHide={this.props.onHide}>
          <Modal.Header closeButton>
            <Modal.Title className="w-100">
              <div className="d-flex justify-content-between align-items-center">
                <div>Подборка</div>
                <div>
                  <div
                    className="btn btn-light mr-2"
                    onClick={this.onItemCheckAll}
                  >
                    <i className="fa fa-check-square-o mr-2"></i>Выбрать все
                  </div>
                  <div
                    className="btn btn-light mr-2"
                    onClick={this.onItemUnCheckAll}
                  >
                    <i className="fa fa-square-o mr-2"></i>Снять все
                  </div>
                  <div className="btn btn-light" onClick={this.onDeleteChecked}>
                    <i className="fa fa-times mr-2"></i>Удалить выбранные
                  </div>
                </div>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Blocker on={this.state.pending} hAuto>
              {cart.cartItems.map((item) => this.renderItem(item))}
            </Blocker>
          </Modal.Body>
          <Modal.Footer>
            {documents.length > 0 && (
              <Dropdown>
                <Dropdown.Toggle
                  variant="primary"
                  id="dropdown-basic"
                  onMouseDown={(e) => {
                    e.preventDefault();
                  }}
                >
                  Сформировать документ
                  <Dropdown.Menu>
                    {documents.map((item) => {
                      return (
                        <Dropdown.Item
                          key={item.key}
                          onClick={() => this.onDocumentClick(item)}
                        >
                          <span
                            className={`svg-icon mr-2 svg-icon-${item.iconColor}`}
                          >
                            {item.icon}
                          </span>{" "}
                          {item.label}
                        </Dropdown.Item>
                      );
                    })}
                  </Dropdown.Menu>
                </Dropdown.Toggle>
              </Dropdown>
            )}
            <button onClick={this.props.onHide} className="btn btn-light">
              Отмена
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
